import { gql } from '@apollo/client';

export const CREATE_FLASH_SALES_CHECKOUT_PAGE = gql`
  mutation CreateFlashSalesCheckoutPage(
    $cart: FlashSalesCart!
    $shippingRate: String!
    $freeShippingThreshold: Int
  ) {
    createFlashSalesCheckoutPage(
      cart: $cart
      shippingRate: $shippingRate
      freeShippingThreshold: $freeShippingThreshold
    ) {
      checkoutUrl
    }
  }
`;

export const GET_PRODUCTS_BY_COLLECTION = gql`
  query GetProductsByCollection($collection: String!) {
    getProductsByCollection(collection: $collection) {
      default_price
      active
    }
  }
`;
